// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"826":"user-rights-roles","893":"login-home-welcome"}[chunkId] || chunkId) + "." + {"160":"b710a227","826":"d33ed909","893":"ef2cdd0e"}[chunkId] + ".css";
};